__turbopack_context__.v({
  "bottom": "wizard-footer-module-scss-module__y7xZbW__bottom",
  "bottom_inner": "wizard-footer-module-scss-module__y7xZbW__bottom_inner",
  "button": "wizard-footer-module-scss-module__y7xZbW__button",
  "center_content_text": "wizard-footer-module-scss-module__y7xZbW__center_content_text",
  "footer_separator": "wizard-footer-module-scss-module__y7xZbW__footer_separator",
  "left": "wizard-footer-module-scss-module__y7xZbW__left",
  "left_content": "wizard-footer-module-scss-module__y7xZbW__left_content",
  "left_content_text": "wizard-footer-module-scss-module__y7xZbW__left_content_text",
  "right": "wizard-footer-module-scss-module__y7xZbW__right",
  "root": "wizard-footer-module-scss-module__y7xZbW__root",
});
